export default __webpack_public_path__ + "static/media/SCIENCE_TECHNOLOGY_AND_COMPUTER_SCIENCE.e923c274.svg";